/* eslint-disable max-len */
/* eslint-disable sort-imports */

import ActionsDetail from '@/components/actions-detail/index.vue';
import Bastanteo from '@/views/shared/bastanteo/index.vue';
import ElementList from '@/components/element-list/index.vue';
import OperationAdd from '@/views/operation-details/operations-add/index.vue';
import OperationInfoBox from '@/views/operation-details/operation-info-box/index.vue';
import AccountInfoAml from '@/views/accounts/accounts-details/account-info-aml/index.vue';
import permissionUser from '@/inheritance/permission-user';
import RelatedDocumentation from '@/views/shared/related-documentation/index.vue';
import RelatedHistoric from '@/views/shared/related-historic/index.vue';
import RelatedInterveners from '@/views/shared/related-interveners/index.vue';
import RelatedIssues from '@/views/shared/related-issues/index.vue';
import RelatedOperations from '@/views/shared/related-operations/index.vue';

import GeneralDetails from '@/views/operation-details/block-details/general-details/index.vue';
import Account from '@/views/operation-details/block-details/account/index.vue';
import AuditingData from '@/views/operation-details/block-details/auditing-data/index.vue';
import DatesOperation from '@/views/operation-details/block-details/dates-operation/index.vue';
import Ordering from '@/views/operation-details/block-details/ordering/index.vue';
import Contributor from '@/views/operation-details/block-details/contributor/index.vue';
import InternalTransfer from '@/views/operation-details/block-details/internal-transfer/index.vue';
import ExternalTransfer from '@/views/operation-details/block-details/external-transfer/index.vue';
import FundInfo from '@/views/operation-details/block-details/fund-info/index.vue';
import Refund from '@/views/operation-details/block-details/refund/index.vue';
import Redemption from '@/views/operation-details/block-details/redemption/index.vue';
import Contribution from '@/views/operation-details/block-details/contribution/index.vue';
import Periodicity from '@/views/operation-details/block-details/periodicity/index.vue';
import Conciliation from '@/views/operation-details/block-details/conciliation/index.vue';
import MasterOperation from '@/views/operation-details/block-details/master-operation';

import FiscalItems from '@/views/operation-details/fiscal-items/index.vue';
import TransferDetails from '@/views/operation-details/transfer-details/index.vue';

const YuriBoleta = () => import(/* webpackChunkName: 'YuriBoleta' */ '@/components/yuri-boleta');

export default {
    name: 'OperationDetails',

    extends: permissionUser,

    props: {
        id: {
            type: String,
            required: false
        }
    },
    components: {
        ActionsDetail,
        ElementList,
        OperationAdd,
        Bastanteo,
        OperationInfoBox,
        AccountInfoAml,
        RelatedHistoric,
        RelatedDocumentation,
        RelatedInterveners,
        RelatedIssues,
        YuriBoleta, // TODO: Veo que este componente no se usa en ningun lado, seria conveniente borrarlo
        RelatedOperations,
        GeneralDetails,
        Account,
        AuditingData,
        DatesOperation,
        Ordering,
        Contributor,
        InternalTransfer,
        ExternalTransfer,
        FundInfo,
        Refund,
        Redemption,
        Contribution,
        Periodicity,
        Conciliation,
        MasterOperation,
        FiscalItems,
        TransferDetails
    },
    /**
     * @override
     */
    data() {
        return {
            operation: null,
            editOperation: [],
            correctAndResendMode: false,
            saving: false,
            savingTitle: 'Guardar cambios',
            submitted: false,
            operationIssuesNotResolved: [],
            operationIssuesResolved: [],
            pendingOperationIssues: 0,
            holder_name: null,
            account_id: null,
            fields: [],
            tabs: ['Detalles', 'Relacionado', 'Casos', 'Bastanteo'],
            tabIndexSelected: 0,
            componentKey: 0,
            editPeriodic: false,
            periodicityOptions: [
                {
                    key: 'MENSUAL',
                    name: this.$t(`operations.periodicity_options.MENSUAL`)
                },
                {
                    key: 'TRIMESTRAL',
                    name: this.$t(`operations.periodicity_options.TRIMESTRAL`)
                },
                {
                    key: 'SEMESTRAL',
                    name: this.$t(`operations.periodicity_options.SEMESTRAL`)
                },
                {
                    key: 'ANUAL',
                    name: this.$t(`operations.periodicity_options.ANUAL`)
                }
            ],
            revaluationOptions: [
                {
                    key: 'no-increase',
                    name: this.$t(`operations.revaluation_options.no-increase`)
                },
                {
                    key: 'LINEAL',
                    name: this.$t(`operations.revaluation_options.LINEAL`)
                },
                {
                    key: 'PORCENTUAL',
                    name: this.$t(`operations.revaluation_options.PORCENTUAL`)
                },
                {
                    key: 'ACUMULATIVO',
                    name: this.$t(`operations.revaluation_options.ACUMULATIVO`)
                }
            ],
            formattedPeriodicOperation: {},
            parentOperation: null,
            numberItemsNotValidated: 0,
            pendingItems: new Set(),
            scoringAml: []
        };
    },
    /**
     * @override
     */
    watch: {
        '$route': {
            /**
             * Comprobamos con un watch si la URL ha cambiado y obtenemos los datos
             */
            handler() {
                this.operation = null;
                if (this.$route.name !== 'operations_add') {
                    this.fetchData();
                } else {
                    this.operation = {};
                }
            },
            immediate: true
        }
    },

    /**
     * @override
     */
    mounted() {
        this.$root.$off('refresh_operation', this.fetchData);
        this.$root.$on('refresh_operation', this.fetchData);
        this.$root.$off('emit_items_not_validated', this.updateItemsNotValidated); // Eliminar eventos anteriores
        /**
         * TOTAL de items no validados
         * Emit lanzado desde el componente BastanteoGroup
         */
        this.$root.$on('emit_items_not_validated', this.updateItemsNotValidated);
    },
    /**
     * @override
     */
    beforeDestroy() {
        // Al destruir el componente, se destruyen los listener de eventos en el root
        this.$root.$off('refresh_operation', this.fetchData);
        this.$root.$off('emit_items_not_validated', this.updateItemsNotValidated);
    },
    methods: {
        /**
         * Obtenemos la información de la cuenta
         */
        fetchData() {
            this.numberItemsNotValidated = 0;
            this.pendingItems.clear();
            // this.uuid_operation = this.id || this.$route.params.uuid;
            this.tabIndexSelected = +localStorage.getItem(`tabs_operation_${this.uuid_operation}`);
            this.loadOperationIssues(this.uuid_operation);
            this.loadOperation(this.uuid_operation);
        },
        /**
         * Obtenemos la cuenta desde el servicio
         * @param {String} uuid ID de la cuenta
         */
        loadOperation(uuid) {
            if (!uuid) {
                return;
            }
            this.$operationsService.getOperationsByUUId(uuid)
                .then(async res => {
                    this.$store.dispatch('loaderStore/isVisible', false);
                    this.operation = res.data.operation;
                    if (this.is_operation_transfer && !this.is_operation_pp) {
                        await this.addGestorToOperation();
                    }

                    if (this.amlAllowed && this.operation.account_id) {
                        const interveners = await this.getAccountInterveners(this.operation.account_id);
                        if (interveners && interveners.length) {
                            this.checkIntervenersRisk(interveners);
                        }
                    }

                    this.fields = Object.keys(this.operation);
                    this.componentKey++;
                })
                .catch(err => {
                    this.$toast.error(err.name, err.message);
                });
        },

        async getAccountInterveners(accountUuid) {
            try {
                const res = await this.$accountsService.getAccountInterveners(accountUuid);
                return res.data.accounts_intervener || [];
            } catch (error) {
                console.error('Error obteniendo intervinientes de cuenta:', error);
                return [];
            }
        },

        async checkIntervenersRisk(interveners) {
            try {
                const res = await Promise.allSettled(interveners.map(i => this.$intervenersService.getIntervenerAml(i.uuid)));

                this.scoringAml = res
                    .map((result, index) => {
                        if (
                            result.status === 'fulfilled' &&
                            ['high', 'medium'].includes(result.value.data.risk)
                        ) {
                            const data = result.value.data;
                            const intervener = interveners[index];
                            return {
                                aml: {
                                    risk: data.risk,
                                    scoring: data.scoring,
                                    uuid: data.pibisi_uuid,
                                    active_flags: data.active_flags,
                                    customer_link: data.customer_link
                                },
                                name: `${intervener.name} ${intervener.lastname_1 || ''} ${intervener.lastname_2 || ''}`.trim(),
                                document_id: intervener.document_id,
                                uuid: intervener.uuid
                            };
                        }
                        return null;
                    })
                    .filter(Boolean); // Quitar nulos
            } catch (error) {
                console.error('Error fetching risk info', error);
            }
        },

        filteredFlags(flags) {
            return flags.filter(f => !(f === 'is_high_risk' && flags.length > 1));
        },

        /**
         * Obtenemos obtenemos las incidencias del interviniente desde el servicio
         * @param {String} uuid ID del interviniente
         */
        loadOperationIssues(uuid) {
            this.$operationsService.getOperationIssues(uuid)
                .then(res => {
                    this.operationIssues = res.data.operations_issues || [];
                    this.operationIssues = this.operationIssues.filter(item => item.uuid);
                    this.operationIssuesResolved = this.operationIssues.filter(item => item.status === 'RESOLVED');
                    this.operationIssuesNotResolved = this.operationIssues.filter(item => item.status !== 'RESOLVED');
                    this.pendingOperationIssues = this.operationIssuesNotResolved.length;
                });
        },
        /**
         * Indicamos el tab activo
         * @param {Number} index Indice del tab activo
         */
        setTabIndexSelected(index) {
            this.tabIndexSelected = index;
            localStorage.setItem(`tabs_operation_${this.uuid_operation}`, index);
        },
        /**
         * Update operation information on status update
         */
        operationStatusHasChanged() {
            this.fetchData();
        },

        /**
         * Show edit operation
         */
        showEditOperation() {
            this.editOperation.push(this.operation.id_object);
        },
        /**
         * Show edit operation
         */
        hideEditOperation() {
            this.editOperation = this.editOperation.filter(item => item !== this.operation.id_object);
        },
        /**
         * Close tab
         */
        closeItem() {
            const items = this.$store.getters['yuriMenuStore/items'];
            let indexMenu = 0;
            for (let index = 0; index < items.length; index++) {
                const element = items[index];
                if (element.route.name === 'operations_add') {
                    indexMenu = index;
                    const operationAddPath = 'OperationAdd';
                    this.$store.dispatch('formStore/deleteForm', `${this.$route.path}__${operationAddPath}`);
                }
            }
            if (this.id_object) {
                let last = null;
                if (this.object_type === 'account') {
                    last = items.find(x => x.route.name === 'accounts_uuid' && x.route.params.uuid === this.id_object);
                }
                if (this.object_type === 'intervener') {
                    last = items.find(x => x.route.name === 'interveners_uuid' && x.route.params.uuid === this.id_object);
                }
                this.$store.dispatch('yuriMenuStore/removeItem', indexMenu).then(() => {
                    this.$store.dispatch('yuriMenuStore/setActiveItem', last).then(() => {
                        this.$router.replace(last.route);
                    });
                });
            } else {
                const last = items.find(x => x.route.name === 'operations');
                if (last) {
                    this.$store.dispatch('yuriMenuStore/removeItem', indexMenu).then(() => {
                        this.$store.dispatch('yuriMenuStore/setActiveItem', last).then(() => {
                            this.$router.replace(last.route);
                        });
                    });
                } else {
                    this.closeActiveTab('dashboard');
                }
            }
        },
        /**
         * Get refund section title
         * @return {String} refund section title
         */
        getRefundTitle() {
            if (this.operation.amount_shares_indicator === 'I') {
                return 'REEMBOLSO POR IMPORTE NETO';
            } else if (this.operation.amount_shares_indicator === 'B') {
                return 'REEMBOLSO POR IMPORTE BRUTO';
            } else if (this.operation.amount_shares_indicator === 'P') {
                return 'REEMBOLSO POR PARTICIPACIONES';
            } else if (this.operation.is_total_redemption) {
                return 'REEMBOLSO TOTAL';
            } else {
                return 'REEMBOLSO';
            }
        },
        /**
         * @override
         */
        close_edit_operation() {
            this.editOperation = this.editOperation.filter(item => item !== this.operation.id_object);
            this.fetchData();
        },
        /**
         * ACTUALIZA ITEMS NO VALIDADOS
         * Emit lanzado desde el componente BastanteoItem
         *
         * @param {Object} items: items no validados
         *
         */
        updateItemsNotValidated(items) {
            let newItems = 0;
            items.forEach(item => {
                if (!this.pendingItems.has(item.uuid)) {
                    this.pendingItems.add(item.uuid);
                    newItems++;
                }
            });

            //Sumar solo los nuevos elementos
            this.numberItemsNotValidated += newItems;
        },

        // Rellenar correctamente el cnmv del fondo
        async addGestorToOperation() {
            const cfg = {
                params: {}
            };
            const cnmv = this.operation.main_product ?
                this.operation.main_product.cnmv_fund_register_number :
                this.operation.product.cnmv_fund_register_number;
            cfg.params['$filter'] = `{"cnmv":[{"eq": ${cnmv} }]}`;

            const res = await this.$accountsService.getCnmvData(cfg);
            this.operation.gestor = res.data.cnmv_data[0];
        },
        // Mostrar y ocultar el modo de corrección y reenvío de operación
        showCorrectAndResendOperation() {
            this.editOperation.push(this.operation.id_object);
            this.correctAndResendMode = true;
        },
        // Ocultar el modo de corrección y reenvío de operación
        hideCorrectAndResendOperation() {
            this.editOperation = this.editOperation.filter(item => item !== this.operation.id_object);
            this.correctAndResendMode = false;
        },
        // Cerrar el modo de corrección y reenvío de operación y volver a cargar los datos
        close_correct_and_resend_operation() {
            this.correctAndResendMode = false;
            this.editOperation = this.editOperation.filter(item => item !== this.operation.id_object);
            this.fetchData();
        }
    },
    computed: {
        operation_status: {
            get() {
                return this.operation
                    ? this.operation.operation_status
                    : undefined;
            }
        },
        uuid_operation: {
            get() {
                return this.id || this.$route.params.uuid;
            }
        },
        object_type: {
            get() {
                return this.$route.query.type;
            }
        },
        id_object: {
            get() {
                return this.$route.query.uuid;
            }
        },
        is_operation_transfer: {
            get() {
                return this.operation.key_operation_type === 'SOLICITUD_TRASPASO_INTERNO' ||
                    this.operation.key_operation_type === 'SOLICITUD_TRASPASO_EXTERNO_ENTRADA' ||
                    this.operation.key_operation_type === 'SOLICITUD_TRASPASO_EXTERNO_SALIDA';
            }
        },
        is_operation_pp: {
            get () {
                return ['INNOCAPITAL_GLOBAL', 'INNOCAPITAL_MIXTO_GLOBAL'].includes(this.operation.key_product);
            }
        },
        fiscalItemsAllowed() {
            return this.$store.getters['configVarsStore/getAllowFiscalItems'];
        },

        amlAllowed() {
            return this.$store.getters['configVarsStore/getAllowAML'];
        },

        showTransferDetails() {
            return (
              this.operation.key_operation_type === 'TRASPASO_ENTRADA' &&
              this.operation_status === 'FINALIZED' &&
              this.fiscalItemsAllowed
            );
        },

        /**
         * Verifica si una operación periódica puede editarse
         * Las operaciones de suscripción o reembolso periódico no se pueden editar si se crearon hoy
         * Usa el campo created_on para determinar la fecha de creación
         * @return {Boolean} true si se puede editar
         */
        canEditPeriodicOperation() {
            if (!this.operation) return true;

            const isPeriodicOperation =
                this.operation.key_operation_type === 'SOLICITUD_SUSCRIPCION_PERIODICA' ||
                this.operation.key_operation_type === 'SOLICITUD_REEMBOLSO_PERIODICO';
            if (!isPeriodicOperation) {
                return true;
            }

            // Si es operación periódica, verificar si se creó hoy
            const creationField = this.operation.created_on || this.operation.created_at || this.operation.creation_date;
            if (creationField) {
                const createdDate = this.$moment(creationField).format('YYYY-MM-DD');
                const today = this.$moment().format('YYYY-MM-DD');

                // No se puede editar si se creó hoy
                const canEdit = createdDate !== today;
                return canEdit;
            }

            // Si no tiene fecha de creación, permitir edición por defecto
            return true;
        }
    }
};
